<template>
  <h2 v-on="$listeners" ref="header"><slot/></h2>
</template>


<script>
export default {
  name: 'AppSubTitle',

  props: {
    ratio: {
      type: Number,
      default: 1,
    },
  },

  data: () => ({
    observer: null,
    controller: new AbortController(),
  }),

  mounted() {
    this.createObserver();
    addEventListener('resize', () => {
      this.$refs.header.style.removeProperty('font-size');
      this.createObserver();
    }, { signal: this.controller.signal });
  },

  beforeDestroy() {
    this.observer.disconnect();
    this.controller.abort();
  },

  methods: {
    createObserver() {
      const el = this.$refs.header;
      this.observer?.disconnect();
      this.observer = new ResizeObserver(([entry]) => {
        let parentWidth = el.parentNode.clientWidth * this.ratio;
        const styles = getComputedStyle(el.parentNode);
        parentWidth -= parseFloat(styles.paddingLeft) + parseFloat(styles.paddingRight);

        const currentWidth = entry.contentRect.width;
        if (parentWidth >= currentWidth) return;
        const fontSize = getComputedStyle(el).getPropertyValue('font-size').slice(0, -2);
        const newFontSize = fontSize * (parentWidth / currentWidth);
        el.style.setProperty('font-size', `${newFontSize}px`);
      });
      this.observer.observe(el);
    },
  },
}
</script>


<style lang="scss" scoped>
h2 {
  margin: 0;
  font-weight: 700;
  text-transform: uppercase;
  font-size: clamp(8px, 26px, 1em);
  line-height: 1.4;
  box-sizing: border-box;
}
</style>